import { Box } from "grommet";
import React from "react";

export const DaysArray = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

const DaySelector = ({ days, onChange }) => {
    const [selectedDays, setSelectedDays] = React.useState(days);

    const select = (day) => () => {
        setSelectedDays(selectedDays.includes(day) ? selectedDays.filter((d) => d !== day) : [...selectedDays, day]);
    };

    React.useEffect(() => {
        onChange(selectedDays);
    }, [selectedDays]);

    return (
        <Box direction="row" gap="small" pad="small">
            {DaysArray.map((day) => (
                <Box key={day} width="36px" pad="xsmall" round="5px" align="center" justify="center" background={selectedDays.includes(day) ? "brand" : "background-front"} hoverIndicator="background" onClick={select(day)}>
                    {day}
                </Box>
            ))}
        </Box>
    );
};

export default DaySelector;
